import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { groupBy } from '../../utils/util.js';
import { ActionToolbarDivider } from './ActionToolbarDivider.js';
import { ActionToolbarGroup } from './ActionToolbarGroup.js';
import { ActionToolbarItem } from './ActionToolbarItem.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["items"];
function ActionToolbar(props) {
  props.items;
    var rest = _objectWithoutProperties(props, _excluded);
  var groups = props.items ? Object.values(groupBy(props.items, "group")) : [];
  var groupWithDividers = groups.reduce(function (acc, grouping, i) {
    var group = i + 1;
    var prevItem = acc[acc.length - 1];
    if (prevItem && prevItem.group !== group) {
      acc.push({
        type: "divider",
        group: group
      });
    }
    if (i === groups.length - 1) {
      grouping[grouping.length - 1].lastItem = true;
    }
    acc.push.apply(acc, _toConsumableArray(grouping));
    return acc;
  }, []);
  return /*#__PURE__*/jsx(ActionToolbarGroup, _objectSpread(_objectSpread({
    role: "toolbar"
  }, rest), {}, {
    children: groupWithDividers.map(function (item, index) {
      return item.type === "divider" ? /*#__PURE__*/jsx(ActionToolbarDivider, {
        group: item.group
      }, index) : /*#__PURE__*/jsx(ActionToolbarItem, _objectSpread({}, item), index);
    })
  }));
}
ActionToolbar.displayName = "ActionToolbar";

export { ActionToolbar };
